// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"366c71b6","453":"f3295058","455":"fc57f281","977":"922cfc1e"}[chunkId] + ".chunk.js";
};